import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loginSetFlowStageWatcher } from "../../redux/actions/loginactioncreators";
import { NewFADVLoginForm } from "./NewFADVLoginForm";
import { LegacyLoginHelpLink } from "./LegacyLoginHelpLink";
import { SafeFormattedMessage } from "./SafeFormattedMessage";

export const SignupSsoRequiredForm = () => {
  const dispatch = useDispatch();
  const signupState = useSelector(state => state.loginForm.signup ?? {});
  const signupMessage = signupState.message ?? "";

  const handleReturnToSignIn = () => {
    dispatch(loginSetFlowStageWatcher({ flowStage: "LOGIN" }));
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleReturnToSignIn}
      headerContent={<FormattedMessage id="signup.ssoRequiredHeader" defaultMessage="Use Single Sign-On (SSO)" description="Header for the signup SSO required page" />}
      submitButtonText={<FormattedMessage id="signup.returnToSignIn" defaultMessage="Return to Sign In" description="Button text to return user from sign-up flow to login form" />}
      middleContent={<LegacyLoginHelpLink />}
      onEscapeKey={handleReturnToSignIn}
    >
      <p className="text-primary-fg text-base leading-6">
        {signupMessage && typeof signupMessage === "object" && signupMessage.id ? (
          <SafeFormattedMessage {...signupMessage} />
        ) : (
          <FormattedMessage
            id="signup.ssoRequiredBlurb"
            defaultMessage='Your email address is associated with an organization that uses Single Sign-On (SSO). To continue, please click the "Return to Sign In" button and login using your company provided credentials. You do not need to complete signup.'
            description="Instructional text shown when signup user must complete login through their organization's SSO"
          />
        )}
      </p>
    </NewFADVLoginForm>
  );
};
